import ApiClient from './ApiClient';

class ProjectNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/notes`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, content) {
    this.projectId = projectId;
    return super.create({ content });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }
}

export default new ProjectNotes();
